import { AppClient } from "../../submodules/rapdv/client/app/AppClient"
import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"
import { CopyText } from "../elements/CopyText"

declare const pjax

export class PageVerifyEmails implements ClientPage {
  private app: AppClient

  constructor(app: AppClient) {
    this.app = app
  }

  getPageId = (): string => {
    return "page-verify-emails"
  }

  execute = (): void => {
    const typeSelect: any = document.querySelector("select[name='type']")
    typeSelect.addEventListener("change", (event) => {
      this.app.pjax.loadUrl(location.pathname + "?type=" + event.target.value)
    })

    // Add copy email button
    const copyButtons = document.querySelectorAll(".btn-copy")
    for (const button of copyButtons) {
      button.addEventListener("click", (event: any) => {
        const email = event.target.getAttribute("data-email")
        CopyText.toClipboard(email)
      })
    }
  }

  onPageClose = (): void => {}
}
